<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-11 " style="padding-top:0">
        <div class="">
          <div class="card-body d-flex flex-column p-0 pb-10">
            <div class="row">
              <div class="col-12 font-weight-bolder font-size-h3 mb-8">
                Forum
              </div>
            </div>
            <div class="categories" v-for="t of tags" :key="t._id">
              <h2 class="py-3">
                {{ t.name }}
                <small>({{ forumCategory(t._id).length }})</small>
              </h2>
              <div
                class="card card-dark element py-3"
                v-for="f in forumCategory(t._id)"
                :key="f._id"
              >
                <router-link :to="'/forums/' + f._id">
                  <div class="row align-items-center p-0">
                    <div class="col-12 col-md-9 pl-10">
                     
                      <h3 class="text-dark-75 font-weight-bold mb-2">
                        <span v-if="forumSolved(f._id)"
                          ><i class="fa fa-check mr-3"></i></span
                        >{{ f.title }}
                        
                      </h3>
                      <div class="d-flex">
                        <div class="date mr-3">
                          <span class="text-muted">Asked </span>{{ f.createdAt | moment("D MMM YYYY") }}</div> 
                          <div class="author mr-3">
                            <span class="author text-muted"
                          >{{ getUserName(f.user) }}</span
                        >
                            </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 text-right d-flex justify-content-end">
                      <div class="views" >
                        <span class=" p-5 text-secondary">
                          <i class="fa fa-eye mr-2"></i>
                          <b class="text-muted">{{ f.views }}</b>
                        </span>
                      </div>
                      <div class="comments" v-if="f.comments">
                        <span class=" p-5">
                          <i class="fa fa-comment mr-2"></i>
                          <b class="text-muted">{{ f.comments.length }}</b>
                        </span>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>

              <div class="add-theme">
                <router-link :to="'/forums/add/' + t._id" class="text-muted">
                  You don't find your answer?... Publish a question!
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import axios from "axios";

export default {
  name: "all-paths",
  components: {},
  data() {
    return {
      form: {
        title: null,
        description: null,
        project: null,
        tags: null
      }
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Forum", subtitle: "All questions" }
    ]);
  },
  computed: {
    forums() {
      return this.$store.getters.getForums;
    },
    tags() {
      return this.$store.getters.getTags;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    me() {
      return this.$store.getters.getMyUser;
    },
    projects() {
      return this.$store.getters.getProjects;
    },
    activeProjects() {
      return this.projects.filter(p => p.isActive);
    }
  },
  methods: {
    forumCategory(tag) {
      return this.forums.filter(f => f.tag === tag);
    },

    getUserName(u) {
      let username = this.users.find(user => user._id == u);
      return username?.firstName + " " + username?.lastName;
    },
    getTagInfo(t) {
      let tag = this.tags.find(tag => tag._id == t);
      return tag?.name;
    },
    forumSolved(i) {
      let forum = this.$store.getters.getForums.find(f => f._id === i);
      return forum.comments.filter(s => s.isSolved).length > 0 ? true : false;
    }
  }
};
</script>

<style lang="scss">
.categories {
  margin-bottom: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
  h2 {
    background: rgb(250, 249, 249);
    font-size: 17px;
    padding: 5px 8px;
    margin: 0;
  }
  .card {
    border-radius: 0;
    h3 {
      font-size: 15px;
    }
    a,i {
      color: #3f4254;
    }
  }
  .user {
    width: 100%;
    max-width: 20px;
    max-height: 20px;
    border-radius: 100px;
    display: inline-block;
    background: rgba(0, 0, 0, 0.1);
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .element {
    transition: all 0.5s;
    &:hover {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
  }
  .add-theme {
    background: rgb(239, 239, 239);
    font-size: 13px;
    padding: 5px 8px;
    margin: 0;
    cursor: pointer;
  }
}
</style>
